export default __webpack_public_path__ + "static/media/fragile_label.3c8b921e.png";